import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import React, { cloneElement, useEffect, useMemo, useState } from 'react';

import 'moment/locale/es';
import { useLocation, useNavigate } from 'react-router-dom';
import './requisitoClienteCreationContent.scss';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { Stepper } from '../../../components/stepper/Stepper';
import { STEPS } from './steps';
import toast from 'react-hot-toast';
import { GET_REQUISITO_CLIENTE_BY_COD_SAP, requisitoClienteAdapter } from '../../../data/graphQL/queries/RequisitoClientes/getRequisitoClienteByCodSap';
import { clienteDataAdapter, GET_CLIENTE_LITE } from '../../../data/graphQL/queries/RequisitoClientes/getClienteLite';
import { CircularProgress } from '@mui/material';
import { GET_REQ_CLIENTES_OPTIONS } from '../../../data/graphQL/queries/RequisitoClientes/getRequisitoClienteOptions';
import { SAVE_REQUISITO_CLIENTES, saveRequisitoClienteAdapter } from '../../../data/graphQL/mutations/RequisitoClientes/SaveRequisitoCliente';

export const RequisitoClienteCreationContent = ({ setChildrenAction, setHeaderContent }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const stateData = location.state;
  const [steps, setSteps] = useState(STEPS);

  const [activeStep, setActiveStep] = useState(0);

  const [fullFormData, setFullFormData] = useState({
    minuta_DNI: false,
    minuta_nombreApellido: false,
    minuta_nroAfiliado: false,
    minuta_nroOC: false,
    minuta_nroRemito: false,
    fA: false,
    editaFechaHasta: false,
    aprobacionMasiva: false,
    telemedicina: false,
    subVentas: false,
    autorizaciones: 0,
    enfermeriaGuardia: 0,
    conformidades: 0,
    nutricionista: 0,
    prescripcion: 0,
    validacion: 0,
    psicologo: 0,
    documentacion_Pac: 0,
    kinesiologo: 0,
    psiquiatra: 0,
    enfermeria: 0,
    tocupacional: 0,
    fonoaudiologo: 0,
    asocial: 0,
    remito_NH: 0,
    remito_FK: 0,
    evolucionMedica: 0,
    bloqueoPaciente: 0,
    bloqueoProrroga: 0,
    bloqueoCotizar: 0,
    bloqueoEnvio: 0,
  });

  const [tipoModulo, setTipoModulo] = useState([]);
  const [docuRespaldatoriaCombo, setDocuRespaldatoriaCombo] = useState([]);
  const [presentacionFactCombo, setPresentacionFactCombo] = useState([]);
  const [tipoAutorizacionCombo, setTipoAutorizacionCombo] = useState([]);
  const [tiempoFacturacionCombo, setTiempoFacturacionCombo] = useState([]);
  const REQUISITOS = [
    { id: 1, name: 'autorizaciones', descripcion: 'Autorización del servicio' },
    { id: 12, name: 'enfermeriaGuardia', descripcion: 'Enfermeria Guardia' },
    { id: 2, name: 'conformidades', descripcion: 'Conformidad del Paciente' },
    { id: 13, name: 'nutricionista', descripcion: 'Nutricionista' },
    { id: 3, name: 'prescripcion', descripcion: 'Prescripción' },
    { id: 4, name: 'validacion', descripcion: 'Validación' },
    { id: 15, name: 'psicologo', descripcion: 'Psicólogo' },
    { id: 5, name: 'documentacion_Pac', descripcion: 'Documentación del Paciente' },
    { id: 16, name: 'kinesiologo', descripcion: 'Kinesiólogo' },
    { id: 8, name: 'evolucionMedica', descripcion: 'Evolución Médica' },
    { id: 17, name: 'psiquiatra', descripcion: 'Psiquiatría' },
    { id: 19, name: 'enfermeria', descripcion: 'Enfermeria' },
    { id: 9, name: 'tocupacional', descripcion: 'Terapia Ocupacional' },
    { id: 14, name: 'fonoaudiologo', descripcion: 'Fonoaudiólogo' },
    { id: 20, name: 'asocial', descripcion: 'Asistente Social' },
    { id: 10, name: 'remito_NH', descripcion: 'Remito NH' },
    { id: 11, name: 'remito_FK', descripcion: 'Remito FK' },
  ];
  const currentStep = useMemo(() => steps.find(step => step.status.toUpperCase() === 'ACTIVE'), [steps]);

  const { loading: clientsOptionsLoading, data: clientesOptions } = useQuery(GET_REQ_CLIENTES_OPTIONS, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!clientesOptions) return;

    const { tipoModulo, documentacionRespaldatoria, presentacionFact, tipoAutorizacion, tiempoFacturacion } = clientesOptions?.requisitoClienteOptions || {};
    setTipoModulo(tipoModulo);
    setDocuRespaldatoriaCombo(documentacionRespaldatoria);
    setPresentacionFactCombo(presentacionFact);
    setTipoAutorizacionCombo(tipoAutorizacion);
    setTiempoFacturacionCombo(tiempoFacturacion);
  }, [clientesOptions]);

  const [getRequisitoClienteByCodSap, { loading: requisitoClienteLoading, data: requisitoClienteData }] = useLazyQuery(GET_REQUISITO_CLIENTE_BY_COD_SAP, {
    fetchPolicy: 'no-cache'
  });

  const [getCliente, { loading: clienteLoading, data: clienteData }] = useLazyQuery(GET_CLIENTE_LITE, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!clienteData) return;

    setFullFormData((prevState) => ({
      ...prevState,
      ...clienteDataAdapter(clienteData.clienteByCodigo.valorEsperado)
    }));
  }, [clienteData]);

  const [saveRequisitoCliente, { loading: saveLoading }] = useMutation(SAVE_REQUISITO_CLIENTES, {
    onCompleted: (data) => {
      if (!!data?.saveRequisitoCliente) {
        toast.success('Requisito de cliente guardado correctamente!');
        navigate('/requisitosClientes');
      } else {
        toast.error('Error al guardar el requisito de cliente');
      }
    }
  });

  useEffect(() => {
    if (!stateData) return;
    getRequisitoClienteByCodSap({
      variables: {
        codSap: stateData?.cliente?.codSap
      }
    });
    getCliente({
      variables: {
        codigo: stateData?.cliente?.codSap
      }
    });
  }, [stateData]);

  useEffect(() => {
    if (!requisitoClienteData) return;

    setFullFormData((prevState) => ({
      ...prevState,
      ...requisitoClienteAdapter(requisitoClienteData?.requisitoClienteByCodSap)
    }));
  }, [requisitoClienteData]);


  useEffect(() => {
    setChildrenAction(() =>
      <div
        className='user-admin-item-footer'>
        <CustomButton
          disabled={activeStep === 0}
          onClick={handleBack}
          previousArrow
          size='small'
          variant='outlined'
          noOutline
          className='back-button'>

          Anterior
        </CustomButton>
        <div className='button-divider'></div>
        {activeStep === steps.length - 1 && stateData.allowedWrite &&
          <CustomButton
            loading={saveLoading}
            onClick={handleSave}
            size='small'
            variant='contained'
            disableElevation>

            Grabar
          </CustomButton>}
        {activeStep < steps.length - 1 &&
          <CustomButton
            onClick={handleNext}
            size='small'
            nextArrow
            variant='outlined'
            noOutline={true}>

            Siguiente
          </CustomButton>}
      </div>
    );

    setHeaderContent(() =>
      <div className='user-header-stepper'>
        <Stepper
          steps={steps} />

      </div>
    );
  }, [
    steps,
    saveLoading,
    fullFormData]
  );

  const refreshStep = (nuevoStep) => {
    setSteps(steps?.map((step) => {
      if (step.order === nuevoStep) {
        return { ...step, status: 'ACTIVE' };
      } else if (step.order < nuevoStep) {
        return { ...step, status: 'COMPLETED' };
      } else {
        return { ...step, status: 'INACTIVE' };
      }
    }));

  };

  const isValidStep = () => {
    if (activeStep === 0) {
      return !Object.entries(requiredFields.datosGenerales).some(([key, displayName]) => {
        if (!fullFormData[key]) {
          toast.error(`El campo ${displayName} es requerido.`);
          return true;
        }
        return false;
      });
    }
    return true;
  };

  const handleNext = () => {
    if (isValidStep()) {
      setActiveStep((step) => {
        const nuevoStep = step + 1;
        refreshStep(nuevoStep);
        return nuevoStep;
      });
    }
  };

  const handleBack = () => {
    setActiveStep((step) => {
      if (step === 0) return step;
      const nuevoStep = step - 1;
      refreshStep(nuevoStep);
      return nuevoStep;
    });

  };

  const handleSave = () => {
    saveRequisitoCliente({
      variables: {
        input: saveRequisitoClienteAdapter(fullFormData, REQUISITOS)
      }
    });
  };

  const handleChangeFullFormData = (name, value) => {
    setFullFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const screenLoading = useMemo(() =>
    requisitoClienteLoading ||
    clienteLoading,
    [
      requisitoClienteLoading || clienteLoading]
  );

  return (
    <div>
      {screenLoading && <div className='tab-loading-section'>
        <CircularProgress />
      </div>}
      {!screenLoading && cloneElement(currentStep.component, {
        allowedWrite: stateData.allowedWrite,
        fullFormData,
        handleChangeFullFormData: (name, value) => handleChangeFullFormData(name, value),
        clientsOptionsLoading,
        tipoModulo,
        docuRespaldatoriaCombo,
        presentacionFactCombo,
        tipoAutorizacionCombo,
        tiempoFacturacionCombo,
        REQUISITOS
      })}
    </div>);

};


const requiredFields = {
  datosGenerales: {
    'mailFact': ' E-Mail Fact',
    'mail': ' E-Mail',
    'dia_Inicio_Fact_Mensual': 'Inicio facturación',
    'dia_Fin_Fact_Mensual': 'Fin facturación',
    'idTmpFact': 'Tiempo Max Fact.',
    'presentacionFact': ' Presentación Fact.',
    'docRespaldatoria': ' Doc. Respaldatoria',
    'idTipoAutorizacion': ' Modo Recepción Autorización'
  }
};